var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"Page_404","template":"page"}},[_c('div',{staticClass:"bg"},[_c('h1',[_vm._v("404 Page not found")])])])}]

export { render, staticRenderFns }